import { Product } from "@/types/liveStreamTypes";
import { Models } from "appwrite";


interface ProductThumbnailGridProps {
  products: Product[];
  selectedIds: string[];
  onSelect: (productId: string) => void;
}

export default function ProductThumbnailGrid({ products, selectedIds, onSelect }: ProductThumbnailGridProps) {
  return (
    <div className="grid grid-cols-3 gap-3">
      {products?.
      filter((post: Models.Document) => post.isActivated).
      map((product) => (
        <div
          key={product.$id}
          onClick={() => onSelect(product.$id)}
          className={`border rounded-md p-2 cursor-pointer transition-colors ${
            selectedIds.includes(product.$id) ? "border-red bg-dark-4" : "border-dark-4"
          }`}
        >
          <img
            src={product.images[0]}
            alt={product.title}
            className="w-full h-20 object-cover rounded-sm"
          />
          <p className="text-sm truncate mt-1 text-off-white">{product.title}</p>
          <p className="text-xs text-light-3">Rs. {product.price}</p>
        </div>
      ))}
    </div>
  );
}